import { render, staticRenderFns } from "./IndustrySegmentSignupStep.vue?vue&type=template&id=20b0df3d&"
import script from "./IndustrySegmentSignupStep.vue?vue&type=script&lang=ts&"
export * from "./IndustrySegmentSignupStep.vue?vue&type=script&lang=ts&"
import style0 from "./IndustrySegmentSignupStep.vue?vue&type=style&index=0&id=20b0df3d&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b0df3d')) {
      api.createRecord('20b0df3d', component.options)
    } else {
      api.reload('20b0df3d', component.options)
    }
    module.hot.accept("./IndustrySegmentSignupStep.vue?vue&type=template&id=20b0df3d&", function () {
      api.rerender('20b0df3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/guest/gsx/signupSteps/IndustrySegmentSignupStep.vue"
export default component.exports